module.exports = __webpack_public_path__ + "static/media/error_asset.550b96a1.svg";